<template>
  <div id="quote" class="sec">
    <v-container>
      <v-row justify="center">
        <div
          class="head"
          data-aos="fade-up"
          :class="MIXIN_SETUP_UI.header"
        >
          Get Quote
        </div>
      </v-row>
      <v-card
        rounded="lg"
        flat
        data-aos="fade-up"
        :class="MIXIN_SETUP_UI.defaultSideMargin"
      >
        <v-form ref="quoteForm">
          <v-row>
            <v-col
              cols="12" sm="12" md="6" lg="6" xl="6"
              :style="{ padding: $vuetify.breakpoint.smAndDown ? '40px' : '100px 40px 100px 150px' }"
            >
              <!-- Name -->
							<v-text-field
								label="Name*"
								type="text"
								ref="Name"
								v-model="name"
								:rules="[() => !!name || 'This field is required']"
								:error-messages="errorMessages"
							></v-text-field>

              <!-- Designation -->
              <v-text-field
								label="Designation*"
								type="text"
								ref="designation"
								v-model="designation"
								:rules="[() => !!designation || 'This field is required']"
								:error-messages="errorMessages"
							></v-text-field>

              <!-- Email Address -->
              <v-text-field
								label="Email Address*"
								type="text"
								ref="emailAddress"
								v-model="emailAddress"
								:rules="[() => !!emailAddress || 'This field is required',
												 () => /.+@.+\..+/.test(emailAddress) || 'Email must be valid']"
								:error-messages="errorMessages"
							></v-text-field>

              <!-- Contact Number -->
              <v-text-field
								label="Contact Number*"
								type="text"
								ref="contactNumber"
								v-model="contactNumber"
								:rules="[() => !!contactNumber || 'This field is required']"
								:error-messages="errorMessages"
							></v-text-field>

              <!-- Company Name -->
              <v-text-field
								label="Company Name*"
								type="text"
								ref="companyName"
								v-model="companyName"
								:rules="[() => !!companyName || 'This field is required']"
								:error-messages="errorMessages"
							></v-text-field>

              <!-- Nature of business -->
              <v-text-field
								label="Nature of business*"
								type="text"
								ref="businessNature"
								v-model="businessNature"
								:rules="[() => !!businessNature || 'This field is required']"
								:error-messages="errorMessages"
							></v-text-field>

              <!-- Employees -->
              <v-select
                ref="employeesTotal"
                v-model="employeesTotal"
                :items="totals"
                label="Total number of employees*"
                :rules="[() => !!employeesTotal || 'This field is required']"
								:error-messages="errorMessages"
              ></v-select>

              <!-- Respondents -->
              <!-- <v-select
                ref="respondentsTotal"
                v-model="respondentsTotal"
                :items="totals"
                label="Total number of respondents*"
                :rules="[() => !!respondentsTotal || 'This field is required']"
								:error-messages="errorMessages"
              ></v-select> -->
            </v-col>
            <v-col
              cols="12" sm="12" md="6" lg="6" xl="6"
              :style="{ padding: $vuetify.breakpoint.smAndDown ? '40px' : '100px 150px 100px 40px' }"
            >
              <!-- Budget -->
              <v-select
                ref="budget"
                v-model="budget"
                :items="budgets"
                label="Annual budget per head"
                :rules="[() => !!budget || 'This field is required']"
								:error-messages="errorMessages"
              ></v-select>

              <!-- HMO Provider -->
              <v-select
                ref="provider"
                v-model="provider"
                :items="['Yes', 'No']"
                label="Do you have an existing HMO provider?*"
                :rules="[() => !!budget || 'This field is required']"
								:error-messages="errorMessages"
              ></v-select>

              <!-- Requirements -->
              <v-textarea
								label="Brief company requirements"
								auto-grow
								ref="requirements"
								v-model="requirements"
                :rules="[() => !!requirements || 'This field is required']"
								:error-messages="errorMessages"
							></v-textarea>
              
              <!-- Submit button -->
              <v-row justify="end" class="text-right">
                <v-col cols="6">
                  <base-button
                    name="Send"
                    color="#0e6ccd"
                    x-large
                    block
                    @click="confirmQuoteInfo()"
                  ></base-button>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>

    <base-confirm-dialog
			v-model="confirmDialog"
			title="Continue"
			message="Would you like to request a quote?"
			@do="saveQuoteInfo()"
		></base-confirm-dialog>

		<base-success-dialog
			v-model="successDialog"
			title="Thank you!"
			message="You successfully submitted your quote request."
		></base-success-dialog>
  </div>
</template>

<script>
  import Repository from "@/api/repositories";
  const FormEmailApi = Repository.get("formEmails");

  export default {
    name: "QuoteSection",

    data: () => ({
      /* form fields */
			name: null,
			designation: null,
			emailAddress: null,
			contactNumber: null,
			companyName: null,
			businessNature: null,
      employeesTotal: null,
      respondentsTotal: null,
      budget: null,
      provider: null,
      requirements: null,
			/* form fields */
			errorMessages: '',
			confirmDialog: false,
      successDialog: false,
      totals: [
        "Below 10",
        "11-50",
        "51-200",
        "201-500",
        "501-1,000",
        "1,001-5,000",
        "Above 5,000"
      ],
      budgets: [
        "Below 20,000",
        "100,000-200,000",
        "200,000-700,000",
        "Above 700,000"
      ]
    }),

    computed: {
      quoteForm() {
        return {
          name: this.name,
          designation: this.designation,
          emailAddress: this.emailAddress,
          contactNumber: this.contactNumber,
          companyName: this.companyName,
          businessNature: this.businessNature,
          employeesTotal: this.employeesTotal,
          respondentsTotal: this.respondentsTotal,
          budget: this.budget,
          provider: this.provider,
          requirements: this.requirements,
        }
      },
    },

    methods: {
      confirmQuoteInfo() {
        if (this.$refs.quoteForm.validate()) this.confirmDialog = true;
      },
      async saveQuoteInfo() {
        this.confirmDialog = false;

        try {
           /**
            * key = quote because request is coming from quote form
            */
          let key = "quote";
          let form = {
            key,
            data: JSON.stringify(this.quoteForm),
            ...this.quoteForm
          };
        
          let save = await FormEmailApi.createViaKey(key, form);

          if (save) {
            this.successDialog = true;
          }
          else {
            console.log("Sorry, there was a problem saving your transaction.");
          }
        }
        catch(error) {
          console.log(error);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.box {
  padding: 80px;
}
</style>